<div class="register-header">
  <h1 class="register-header__title">{{ 'PAGES.REGISTER.TITLE' | translate }}</h1>
  <div class="register-header__actions">
    <button class="htv-selectable htv-button" (click)="navigateToTestPage()" tabindex="-1">Test</button>
    <button class="htv-selectable htv-button" (click)="clearGuestData()" tabindex="-1">Clear Guest Data</button>
    <button class="htv-selectable htv-button" (click)="resetApp()" tabindex="-1">Reset App</button>
    <button class="htv-selectable htv-button" *ngIf="canDownloadAndUpgradeApp" (click)="upgradeApp()" tabindex="-1">
      Upgrade App
    </button>
    <button class="htv-selectable htv-button" (click)="reboot()" tabindex="-1">Reboot</button>
    <button class="htv-selectable htv-button htv-focus" *ngIf="isRegistered" (click)="restartApp()" tabindex="-1">
      {{ 'PAGES.REGISTER.BACK' | translate }}
    </button>
  </div>
</div>

<div class="register-system">
  <div class="register-container htv-selectable htv-scrollable">
    <div class="register-inner-container">
      <h1>{{ 'PAGES.REGISTER.INFORMATIONS' | translate }}</h1>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.SERVER' | translate }}</div>
        <div class="register-keyvalue__value">{{ serverName }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.SERVER_URL' | translate }}</div>
        <div class="register-keyvalue__value">{{ serverUrl }}</div>
      </div>
      <div class="separator"></div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.MODEL' | translate }}</div>
        <div class="register-keyvalue__value">{{ systemData.model }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.MANUFACTURER' | translate }}</div>
        <div class="register-keyvalue__value">{{ systemData.manufacturer }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.SERIAL_NUMBER' | translate }}</div>
        <div class="register-keyvalue__value">{{ systemData.serialNumber }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.APP_VERSION' | translate }}</div>
        <div class="register-keyvalue__value">{{ systemData.appVersion }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.FIRMWARE_VERSION' | translate }}</div>
        <div class="register-keyvalue__value">{{ systemData.firmwareVersion }}</div>
      </div>
      <div class="separator"></div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.IP_ADDRESSES' | translate }}</div>
        <div class="register-keyvalue__value">{{ networkData?.ipAddress }}</div>
      </div>
      <div class="register-keyvalue">
        <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.MAC_ADDRESSES' | translate }}</div>
        <div class="register-keyvalue__value">{{ networkData?.macAddress }}</div>
      </div>
    </div>
  </div>
</div>

<div class="register-status">
  <div class="register-container">
    <div class="register-inner-container">
      <h1>{{ 'PAGES.REGISTER.REGISTER_STATUS' | translate }}</h1>
      <div class="register-keyvalue">
        <div class="register-keyvalue__value htv-success" *ngIf="isRegistered">
          {{ 'PAGES.REGISTER.REGISTERED' | translate }}
        </div>
        <div class="register-keyvalue__value htv-error" *ngIf="!isRegistered">
          {{ 'PAGES.REGISTER.UNREGISTERED' | translate }}
        </div>
      </div>

      <div class="separator"></div>

      <ng-container *ngIf="isRegistered">
        <div class="register-keyvalue" *ngIf="customerId">
          <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.CUSTOMER_ID' | translate }}</div>
          <div class="register-keyvalue__value">{{ customerId }}</div>
        </div>
        <div class="register-keyvalue" *ngIf="deviceId">
          <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.DEVICE_ID' | translate }}</div>
          <div class="register-keyvalue__value">{{ deviceId }}</div>
        </div>
        <div class="register-keyvalue" *ngIf="deviceName">
          <div class="register-keyvalue__key">{{ 'PAGES.REGISTER.DEVICE_NAME' | translate }}</div>
          <div class="register-keyvalue__value">{{ deviceName }}</div>
        </div>
      </ng-container>

      <ng-container *ngIf="!isRegistered">
        <div class="register-container">
          <app-customer-register-widget></app-customer-register-widget>
        </div>
        <div class="separator"></div>
        <div class="register-container">
          <app-device-register-widget></app-device-register-widget>
        </div>
      </ng-container>
    </div>
  </div>
</div>
